import axios from "axios";
import router from "@/router";
const request = axios.create({
  baseURL: "https://diandianzhuan.beijing888.com",
});
// 请求拦截器
request.interceptors.request.use(
  (config) => {
    config.headers.Authorization = `${localStorage.getItem("token")}`;
    return config;
  },
  (error) => {
    return Promise.reject();
  }
);
var that = this;
//响应拦截器
request.interceptors.response.use(
  (res) => {
    if (res.data.code == 401) {
      localStorage.clear();
      router.push("login");
    } else {
      return res.data;
    }
  },
  (err) => {
    //拦截到失败的数据
    return Promise.reject(err);
  }
);

export default request;
